<template>
    <div v-if="this.no_content" class="wrapper presentation-page no-content">
        <div class="spinner"></div>
    </div>
    <div v-else class="wrapper presentation-page">

        <vue-backTop v-if="false"></vue-backTop>
        <vue-backTop v-if="true" :height="600" :bottom="50" :right="30" @onClick="" @complete="">
            <div class="backtop">
                <i class="fas fa-spade display-5 text-info"></i>
            </div>
        </vue-backTop>

        <div id="poker-spot" data-background-color="white">
            <div class="space-100"></div>
            <div class="container">
                <div class="mb-5">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }"><span class="text-black-50"><i class="fa fa-home"></i></span></el-breadcrumb-item>
                        <el-breadcrumb-item><span class="text-black-50">大会一覧</span></el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>

            <div class="container">
                <div class="mb-0 text-right">
                    <social-sharing
                        :url="currentURL()"
                        title="ポーカーの大会一覧 | ポーカーナビ - 全国のポーカースポット、サークル、トーナメント情報を配信！"
                        description="ポーカーナビがお届けするポーカーの大会一覧です"
                        quote="ポーカーナビがお届けするポーカーの大会一覧です"
                        :hashtags="getHashtags()"
                        twitter-user="PokerNavi_JP"
                        inline-template>
                        <div>
                            <network network="facebook">
                                <div class="sns_share fb">
                                    <i class="fab fa-facebook-f mr-1" style="color:#fff"></i>
                                    <span class="font-weight-bold" style="font-size:.8rem">Share</span>
                                </div>
                            </network>
                            <network network="twitter">
                                <div class="sns_share twitter">
                                    <i class="fab fa-twitter mr-1" style="color:#fff"></i>
                                    <span class="font-weight-bold" style="font-size:.7rem;vertial-align:middle">ツイート</span>
                                </div>
                            </network>
                        </div>
                    </social-sharing>
                </div>
            </div>
            <div class="container">
                <h6 class="with-title-dark">大会一覧</h6>
                <div class="row">

                    <div class="w-100">

                        <paginate
                              v-if="true"
                              v-model="currentPage"
                              :page-count="meta.total_pages"
                              :click-handler="changePage"
                              :page-range="pageRange"
                              :break-view-text="''"
                              :margin-pages="0"
                              :prev-text="'«'"
                              :next-text="'»'"
                              :initial-page="meta.current_page"
                              :force-page="meta.current_page"
                              :container-class="'vuejs-paginate paginationi-container justify-content-center mb-5 mt-3'"
                              :break-view-class="'vuejs-paginate-break-view'"
                              :page-class="'vuejs-paginate-page'"
                              :page-link-class="'vuejs-paginate-page-link'"
                              :prev-class="'vuejs-paginate-prev'"
                              :prev-link-class="'vuejs-paginate-prev-link'"
                              :next-class="'vuejs-paginate-next'"
                              :next-link-class="'vuejs-paginate-next-link'"
                              :hide-prev-next=true
                            >
                        </paginate>
                    </div>


                    <isotope ref="cpt" :options='isotopeOptions' v-images-loaded:on.progress="layout" :list="events" class="_card-columns container pull-left cards-wide-device">

                        <div class="grid-sizer"></div>
                            <div v-for="(event, i) in events" :key="i" class="isotope-card">
                                <div v-if="i == 4" class="adsense-infeed text-center mb-4">
                                    <dfp-slot v-if="true"
                                        path="/21867335047/pokernavi/pokernavi-top-events"
                                        :size="dfpSlotSize('div-gpt-ad-1580356736019-0')"
                                        id="div-gpt-ad-1580356736019-0"
                                    />
                                </div>
                                <router-link v-if="event.unique_domain !== null && event.unique_domain !== ''" :to="event.unique_domain" tag="a" class="front">
                                    <div style="background-color:white;"
                                         class="card"
                                         :key="i"
                                         :data-background-color="setOrange(event.charged ? event.thumbnail : '')">
                                        <div v-if="event.thumbnail !== null" class="card-image">
                                            <img :src="event.thumbnail" class="img rounded" />
                                        </div>
                                        <div class="card-body" :class="{ 'add-new' : addNewAtEvent(event) }">
                                            <span v-if="addNewAtEvent(event)" class="dog-ear text-white"></span>
                                            <h6 class="category text-primary font-weight-normal">
                                                <span class="">【決勝】</span>
                                                <span v-if="event.end !== null" class="py-1 px-2" style="border-bottom:1px solid #ccc">{{event.end | dayjs }}</span>
                                                <span v-else class="py-1 px-2">---</span>
                                            </h6>
                                            <h5 class="card-title font-weight-bold">{{event.title}}</h5>
                                            <p v-if="event.charged" class="card-description" v-html="$options.filters.readmore(event.overview, 100)"></p>
                                        </div>
                                    </div>
                                </router-link>
                                <router-link v-else :to="{ name: 'event', params: { id: event.id }}" tag="a" class="front">
                                    <div style="background-color:white;"
                                         class="card"
                                         :key="i"
                                         :data-background-color="setOrange(event.charged ? event.thumbnail : '')">
                                        <div v-if="event.thumbnail !== null" class="card-image">
                                            <img :src="event.thumbnail" class="img rounded" />
                                        </div>
                                        <div class="card-body" :class="{ 'add-new' : addNewAtEvent(event) }">
                                            <span v-if="addNewAtEvent(event)" class="dog-ear text-white"></span>
                                            <h6 class="category text-primary font-weight-normal">
                                                <span class="">【決勝】</span>
                                                <span v-if="event.end !== null" class="py-1 px-2" style="border-bottom:1px solid #ccc">{{event.end | dayjs }}</span>
                                                <span v-else class="py-1 px-2">---</span>
                                            </h6>
                                            <h5 class="card-title font-weight-bold">{{event.title}}</h5>
                                            <p v-if="event.charged" class="card-description" v-html="$options.filters.readmore(event.overview, 100)"></p>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                    </isotope>

                        <div class="w-100">
                            <paginate
                              v-if="true"
                              v-model="currentPage"
                              :page-count="meta.total_pages"
                              :click-handler="changePage"
                              :page-range="pageRange"
                              :break-view-text="''"
                              :margin-pages="0"
                              :prev-text="'«'"
                              :next-text="'»'"
                              :initial-page="meta.current_page"
                              :force-page="meta.current_page"
                              :container-class="'vuejs-paginate paginationi-container justify-content-center my-5'"
                              :break-view-class="'vuejs-paginate-break-view'"
                              :page-class="'vuejs-paginate-page'"
                              :page-link-class="'vuejs-paginate-page-link'"
                              :prev-class="'vuejs-paginate-prev'"
                              :prev-link-class="'vuejs-paginate-prev-link'"
                              :next-class="'vuejs-paginate-next'"
                              :next-link-class="'vuejs-paginate-next-link'"
                              :hide-prev-next=true
                            >
                            </paginate>
                        </div>

                    <div class="space-50"></div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
  import {
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    Card,
    Collapse,
    CollapseItem,
    NukButton,
    Pagination,
  } from '@/components';
  import {
    Button,
    ButtonGroup,
    Carousel,
    CarouselItem,
    Loading,
    Table,
    TableColumn,
  } from 'element-ui';
  import axios from "axios";
  import dayjs from 'dayjs';
  import {API_ENDPOINT} from '@/constants'
  import DfpSlot from '../components/DfpSlot.vue'
  import isotope from 'vueisotope'
  import imagesLoaded from 'vue-images-loaded'

  export default {
    name: 'events',
    bodyClass: 'presentation-page',
    components: {
      Badge,
      Card,
      Collapse,
      CollapseItem,
      [NukButton.name]: NukButton,
      [Button.name]: Button,
      [ButtonGroup.name]: ButtonGroup,
      [Breadcrumb.name]: Breadcrumb,
      [BreadcrumbItem.name]: BreadcrumbItem,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Pagination.name]: Pagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      DfpSlot,
      isotope
    },
    directives: {
      imagesLoaded
    },
    methods: {
      layout () {
        this.$refs.cpt.layout('masonry');
      },
      dfpSlotSize: function(key) {
        let dfp_slots_sizes = this.dfp_slots[key]
        if (1200 <= window.innerWidth) {
          return dfp_slots_sizes['336']
        } else if(768 <= window.innerWidth && window.innerWidth < 1199) {
          return dfp_slots_sizes['336']
        } else if(518 <= window.innerWidth && window.innerWidth < 768) {
          return dfp_slots_sizes['336']
        } else if (window.innerWidth <= 517) {
          return dfp_slots_sizes['336']
        }
      },
      addNewAtEvent: function(event) {
        let day7ago = dayjs(Date.now()).add(-5, 'days')
        if (event.is_new && (dayjs(event.updated_at).diff(day7ago) > 0)) {
          return 'add-new';
        }
      },
      setOrange: function(image) {
        if (!image) {
          //return 'orange';
          return 'gray';
        }
      },
      setTypeBlog: function(index) {
        if (index%3 !== 0) {
          return 'blog';
        }
      },
      scrollToSpot() {
        event.preventDefault()
        this.$SmoothScroll(
          document.querySelector('#poker-spot'),
          400,
          null,
          null,
          'y'
        )
      },
      changePage: function(pageNum) {
        this.currentPage = Number(pageNum);
        let endpoint = this.$route.fullPath
        if (endpoint.match('p=\d*')) {
            endpoint = endpoint.replace(/p=\d*/, '')
        }
        if (this.currentPage > 1) {
            this.$router.push(endpoint + `?p=${pageNum}` )
        } else {
            this.$router.push(endpoint)
        }
      },
      clickCallback: function(pageNum) {
        console.log(pageNum)
      },
      getPosts: function(pageNum) {
        let api_endpoint = this.baseUrl+'events/?attribute=1'
        if (this.$route.query.p && this.$route.query.p > 1) {
            api_endpoint = api_endpoint + `&page=${this.$route.query.p}`
        }
        axios
          .get(api_endpoint)
          .then(response => {
            // STG APIの場合、resultsとcount形式で返ってくる
            if (response.data.results) {
              this.events = response.data.results
              // ページネーション情報を計算
              const totalCount = response.data.count || response.data.results.length
              const currentPage = this.$route.query.p ? Number(this.$route.query.p) : 1
              const perPage = 20
              this.meta = {
                total_pages: Math.ceil(totalCount / perPage),
                current_page: currentPage
              }
            } else {
              // 本番APIの場合、meta形式で返ってくる
              this.meta = response.data.meta || {}
              this.events = response.data.events || response.data || []
            }
            this.no_content = false
          })
          .catch(response => {
            console.log(response);
            this.events = []
            this.meta = { total_pages: 1, current_page: 1 }
            this.no_content = false
          });
      },
      setPages () {
        let numberOfPages = Math.ceil(this.events.length / this.perPage);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
        }
      },
      addToFavorite: function(arrayPosts) {
        this.events = arrayPosts
      },
    },
    mounted() {},
    async created() {
      try {
        this.loadingInstance = Loading.service({ fullscreen: true });
        if (this.$route.query.p)
            this.currentPage = Number(this.$route.query.p)

        document.title = 'ポーカーの大会一覧 | ポーカーナビ - 全国のポーカースポット、サークル、トーナメント情報を配信！'
        this.getPosts();
      } catch (e) {
        //
      } finally {
        this.loadingInstance.close();
      }
    },
    watch: {
      posts() {
        this.setPages();
      },
      events: function() {
        this.$nextTick(() => {
            var positionY = sessionStorage.getItem('positionY')
            scrollTo(0, positionY);
            setTimeout(function(){
                scrollTo(0, positionY);
                }, 500);
            })
      }
    },
    computed: {
      getItems: function () {
        let start = (this.currentPage - 1) * this.perPage;
        let end = this.currentPage * this.perPage;
        return this.events.slice(start, end);
      },
      getPageCount: function () {
        return Math.ceil(this.events.length / this.perPage);
      }
    },
    filters: {
      dayjs: function (date) {
        return dayjs(date).format('YYYY年MM月DD日 (ddd)');
      },
    },
    data() {
      return {
        no_content: true,
        meta: {},
        events: [],
        filters: {},
        loadingInstance: null,
        baseUrl: API_ENDPOINT,
        currentPage: 1,
        perPage: 20,
        pageRange: 5,
        isotopeOptions: {
          masonry: {
            gutter: 20,
            fitWidth: true
          }
        },
        dfp_slots: {
          'div-gpt-ad-1571972845074-0': { // 不明
            300: [300, 250],
            336: [336, 280]
          },
          'div-gpt-ad-1580282482771-0': { // 不明
            300: [300, 250],
            336: [336, 280]
          },
          'div-gpt-ad-1580355841225-0': { // circles
            300: [300, 250],
            336: [336, 280]
          },
          'div-gpt-ad-1580353644223-0': { // spots
            300: [300, 250],
            336: [336, 280]
          },
          'div-gpt-ad-1580356736019-0': { // events
            336: [336, 280]
          },
          'div-gpt-ad-1580361234575-0': { // footer
            300: [300, 250]
          },
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .github-buttons {
        display: flex;
        align-content: center;
    }
</style>
